import { RootState } from '../store';

const selectMeeting = {
  meeting: (state: RootState) => state.meeting.meeting,
  meetingId: (state: RootState) => state.meeting.meeting?.id,
  session: (state: RootState) => state.meeting.session,
  mediaDestinations: (state: RootState) => state.meeting.mediaDestinations,
};

export default selectMeeting